// Image addresses that Cloudflare can store at its Manila edge (founder, 2026-10-23: "images taking so long to load").
// Next's optimizer lives at /_next/image?url=..., an address with no file type, and Cloudflare only stores addresses
// that end in one. This loader gives every image /img/<width>/<quality>/<source>.jpg instead; the route
// app/img/[w]/[q]/[file]/route.ts hands it to the same optimizer and returns it with a one-year cache instruction.
// The source is base64url-encoded so slashes and query strings survive inside one path segment.

type LoaderArgs = { src: string; width: number; quality?: number }

function b64url(s: string): string {
  const bytes = new TextEncoder().encode(s)
  let bin = ""
  for (const b of bytes) bin += String.fromCharCode(b)
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
}

export default function cdnImageLoader({ src, width, quality }: LoaderArgs): string {
  if (src.startsWith("data:") || src.endsWith(".svg")) return src
  return `/img/${width}/${quality || 75}/${b64url(src)}.jpg`
}
